import React, { FC } from 'react';

import { Box, Flex, Text } from '@chakra-ui/react';

import { EVerificationMethod } from './types';
import { ArrowNextIcon, EmailIcon, SMSIcon } from '../../../Icons';
import { EColor, ETextVariant } from '../../../Theme';

interface IVerificationMethodItem {
  method: EVerificationMethod;
  content: string;
  clickHandler: (method: EVerificationMethod) => void;
  format?: (text: string) => string;
}

export const VerificationMethodItem: FC<IVerificationMethodItem> = ({
  method,
  content,
  clickHandler,
  format,
}) => {
  return (
    <Box
      _hover={{ bg: EColor.Neutral15 }}
      alignItems="center"
      as="button"
      borderColor={EColor.Neutral15}
      borderWidth="1px"
      cursor="pointer"
      display="flex"
      h="44px"
      justifyContent="space-between"
      maxW={{ sm: '330px' }}
      mb="16px"
      px="8px"
      w="100%"
      onClick={() => clickHandler(method)}
    >
      <Flex alignItems="center">
        {method === EVerificationMethod.EMAIL ? <EmailIcon /> : <SMSIcon />}
        <Text
          mx="8px"
          overflow="hidden"
          textOverflow="ellipsis"
          variant={ETextVariant.SmallBold}
          whiteSpace="pre"
        >
          {format?.(content) ?? content}
        </Text>
      </Flex>
      <ArrowNextIcon />
    </Box>
  );
};
